import React from "react"
import { Link } from "react-router-dom"

// An organizer's name opening the organizer's CPanel profile, as the event details do; without an id it stays text.
export default function OrganizerLink({ organizer, children }) {
  return organizer?.id ? <Link to={`/accounts/organizers/${organizer.id}`}>{children}</Link> : <>{children}</>
}
